import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var initialState = {
  status: false,
  products: [],
  delivery: false,
  order: false
};
export var isCartAvailable = createAsyncThunk('cart/availability', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var products, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            products = _ref.products;
            _context.next = 3;
            return axios({
              method: 'post',
              url: process.env.NEXT_PUBLIC_API + '/api/cart/availability',
              data: {
                products: products
              },
              headers: {
                'Content-Type': 'application/json'
              },
              withCredentials: true
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
var cartSlice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {
    saveProducts: function saveProducts(state, action) {
      var _action$payload = action.payload,
          products = _action$payload.products,
          status = _action$payload.status;
      state.products = products;
      state.status = status;
    },
    setStatus: function setStatus(state, action) {
      state.status = action.payload;
    },
    addDelivery: function addDelivery(state, action) {
      state.delivery = action.payload.delivery;
      state.status = 'shipping';
    },
    saveOrder: function saveOrder(state, action) {
      var _action$payload2 = action.payload,
          gateway = _action$payload2.gateway,
          hash = _action$payload2.hash,
          transaction = _action$payload2.transaction;
      state.order = {
        gateway: gateway,
        hash: hash,
        transaction: transaction
      };
      state.status = 'charge';
    },
    emptyCart: function emptyCart(state, action) {
      state.order = false;
      state.products = [];
      state.delivery = false;
      state.status = 'empty';
    },
    retryPayment: function retryPayment(state, action) {
      var _action$payload3 = action.payload,
          gateway = _action$payload3.gateway,
          hash = _action$payload3.hash,
          transaction = _action$payload3.transaction;
      state.order = {
        gateway: gateway,
        hash: hash,
        transaction: transaction
      };
      state.products = [];
      state.delivery = false;
      state.status = 'charge';
    }
  },
  extraReducers: _defineProperty({}, isCartAvailable.fulfilled, function (state, action) {
    var _action$payload4 = action.payload,
        status = _action$payload4.status,
        list = _action$payload4.list;

    if (status) {
      var newProducts = _toConsumableArray(state.products);

      list.forEach(function (el) {
        newProducts = newProducts.map(function (prod) {
          var res;

          if (prod.type == el.type && prod.id == el.id) {
            res = _objectSpread(_objectSpread({}, prod), {}, {
              user_id: el.user_id,
              isAvailable: el.isAvailable
            });

            if (el.isAvailable) {
              res.price = el.price;
            }
          } else {
            res = prod;
          }

          return res;
        });
      });
      state.products = newProducts;
      state.status = 'checked';
    }
  })
});
var _cartSlice$actions = cartSlice.actions,
    saveProducts = _cartSlice$actions.saveProducts,
    setStatus = _cartSlice$actions.setStatus,
    addDelivery = _cartSlice$actions.addDelivery,
    saveOrder = _cartSlice$actions.saveOrder,
    emptyCart = _cartSlice$actions.emptyCart,
    retryPayment = _cartSlice$actions.retryPayment;
export { saveProducts, setStatus, addDelivery, saveOrder, emptyCart, retryPayment };
export default cartSlice.reducer;